import { t } from 'ttag';

import ProductDialogIcon from '@svg/product-dialog.svg';
import { Button } from '@ui/Button';

import s from './ProductDetailsQuestion.sss';

interface Props {
  className?: string,
  disabled?: boolean,
  onClick: () => void,
}

export const ProductDetailsQuestion: React.FC<Props> = ({
  className,
  disabled,
  onClick,
}) => {
  return (
    <div className={className}>
      <Button
        theme="text"
        className={s.button}
        disabled={disabled}
        onClick={onClick}
      >
        <ProductDialogIcon
          className={s.icon}
          width="27"
          height="24"
        />
        <span className={s.text}>
          {t`Поставити запитання`}
        </span>
      </Button>
    </div>
  );
};
